import { p as parsePlayerError } from './errors-f54d265f.js';

function getAdapterOptions(platform) {
  return {
    errorParser: (error) => errorParser(platform, parsePlayerError(error))
  };
}
function errorParser(platform, parsedError) {
  if (!parsedError?.group || !parsedError?.category)
    return void 0;
  const context = `${parsedError.group}: ${parsedError.category}`;
  return {
    name: context,
    description: `[${platform}][${context}] - ${getDescriptionComplement(parsedError)}`,
    metadata: {
      internalCode: parsedError.data?.internalCode,
      requestURL: parsedError.data?.requestURL,
      responseStatusCode: parsedError.data?.response?.status,
      responsePayload: parsedError.data?.response?.data,
      detail: parsedError.data?.originalError
    }
  };
}
function getDescriptionComplement(parsedError) {
  if (parsedError.data?.response?.status) {
    if (!parsedError.data.response.message)
      return `statusCode: ${parsedError.data.response.status}`;
    return `statusCode: ${parsedError.data.response.status} - ${parsedError.data.response.message}`;
  }
  if (parsedError.message)
    return `message: ${parsedError.message}`;
  return `stack: ${parsedError.data?.originalError?.toString?.() || parsedError.data?.internalCode}`;
}

var npaw = /*#__PURE__*/Object.freeze({
  __proto__: null,
  errorParser: errorParser,
  getAdapterOptions: getAdapterOptions
});

export { errorParser as e, getAdapterOptions as g, npaw as n };
//# sourceMappingURL=npaw-e0381ac7.js.map
